/* Hearth & North — theme behaviour. No dependencies. */
(function () {
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  };

  /* ---- toast ---- */
  var toast = document.getElementById('hn-toast');
  var toastMsg = document.getElementById('hn-toast-msg');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toastMsg.textContent = msg;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 6000);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) toast.hidden = true;
  });

  /* ---- cart drawer ---- */
  var drawer = document.getElementById('cart-drawer');
  var lastFocus;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('.drawer__scrim')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMobileNav(); }
  });

  /* ---- mobile nav ---- */
  var mnav = document.getElementById('mobile-nav');
  function closeMobileNav() { if (mnav) { mnav.classList.remove('is-open'); document.body.style.overflow = ''; } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) { mnav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-nav-close]')) closeMobileNav();
  });

  /* ---- cart refresh ---- */
  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        var body = document.querySelector('[data-drawer-lines]');
        if (body) {
          if (!cart.items.length) {
            body.innerHTML = '<p class="empty"><span style="font-family:var(--font-serif);font-size:var(--text-md)">Nothing in here yet.</span></p>';
          } else {
            body.innerHTML = cart.items.map(function (i) {
              var img = i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1') + '" alt="">' : '';
              var variant = i.variant_title && i.variant_title !== 'Default Title' ? '<div class="line__variant">' + i.variant_title + '</div>' : '';
              return '<div class="line"><div class="line__media">' + img + '</div>' +
                '<div><a class="line__title" href="' + i.url + '">' + i.product_title + '</a>' + variant +
                '<div class="line__variant">Qty ' + i.quantity + '</div>' +
                '<button class="line__remove" data-remove="' + i.key + '">Remove</button></div>' +
                '<div class="line__price">' + money(i.final_line_price) + '</div></div>';
            }).join('');
          }
        }
        var sub = document.querySelector('[data-drawer-subtotal]');
        if (sub) sub.textContent = money(cart.total_price);
        var free = document.querySelector('[data-free-ship]');
        if (free) {
          var threshold = parseInt(free.dataset.threshold || '10000', 10);
          var left = threshold - cart.total_price;
          free.textContent = left > 0 ? money(left) + ' from free shipping' : 'Free shipping applied';
        }
        return cart;
      });
  }
  window.hnRefreshCart = refreshCart;

  /* ---- remove line from drawer ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove]');
    if (!btn) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.remove, quantity: 0 })
    }).then(refreshCart);
  });

  /* ---- add to cart (AJAX) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding\u2026'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item.status) throw new Error(item.description || item.message);
        return refreshCart().then(function () {
          showToast((item.product_title || 'Item') + ' \u2014 added.');
          openDrawer();
        });
      })
      .catch(function (err) { showToast(err.message || 'Sorry, that could not be added.'); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; } });
  });

  /* ---- product variant picker ---- */
  document.querySelectorAll('[data-variant-form]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var idField = root.querySelector('[name=id]');
    var priceEl = root.querySelector('[data-price]');
    var submit = root.querySelector('[type=submit]');
    var pdp = root.closest('.pdp');
    var mainImg = pdp ? pdp.querySelector('.pdp__gallery .media--main img') : null;
    function update() {
      var chosen = Array.prototype.map.call(root.querySelectorAll('.opt__input:checked'), function (i) { return i.value; });
      var match = data.find(function (v) { return v.options.every(function (o, idx) { return o === chosen[idx]; }); });
      root.querySelectorAll('[data-option-display]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-display'), 10);
        el.textContent = chosen[idx] || '';
      });
      if (!match) {
        if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.textContent = 'Unavailable'; }
        return;
      }
      idField.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (mainImg && match.image) { mainImg.src = match.image; mainImg.srcset = ''; }
      if (submit) {
        if (match.available) { submit.removeAttribute('aria-disabled'); submit.textContent = submit.dataset.label + ' \u2014 ' + match.price; }
        else { submit.setAttribute('aria-disabled', 'true'); submit.textContent = 'Sold out'; }
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) { if (e.target.classList.contains('opt__input')) update(); });
    update();
  });

  /* ---- tabs ---- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var btns = root.querySelectorAll('[role=tab]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        b.setAttribute('aria-selected', 'true');
        root.querySelectorAll('.tab-panel').forEach(function (p) { p.hidden = p.id !== b.getAttribute('aria-controls'); });
      });
    });
  });

  refreshCart();
})();

/* ---- mobile buy bar: appears on phones when the Add to cart button is off screen ---- */
(function () {
  var bar = document.querySelector('[data-buy-bar]'); if (!bar) return;
  var main = document.querySelector('.pdp__info form[action*="/cart/add"] [type=submit]'); if (!main) return;
  var btn = bar.querySelector('[data-buy-bar-btn]');
  var offscreen = false;
  function sync() {
    btn.textContent = main.textContent.trim().replace(/\s+CAD$/, '');
    if (main.getAttribute('aria-disabled') === 'true') btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
  }
  function place() {
    var show = offscreen && window.innerWidth < 750;
    bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('has-buy-bar', show);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { offscreen = !entries[0].isIntersecting; place(); }, { threshold: 0 }).observe(main);
  }
  window.addEventListener('resize', place);
  new MutationObserver(sync).observe(main, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['aria-disabled'] });
  btn.addEventListener('click', function () {
    if (btn.getAttribute('aria-disabled') === 'true') { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    main.click();
  });
  sync(); place();
})();

/* ---- product gallery lightbox: click any image to enlarge, arrows/swipe/keys to move through all of them, close to go back ---- */
(function () {
  var gallery = document.querySelector('[data-lightbox-gallery]'); if (!gallery) return;
  var lb = document.querySelector('[data-lightbox]'); if (!lb) return;
  var stageImg = lb.querySelector('[data-lightbox-img]');
  var countEl = lb.querySelector('[data-lightbox-count]');
  var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-lightbox-open]'));
  var idx = 0, lastFocus = null;
  function show(i) {
    idx = (i + items.length) % items.length;
    var src = items[idx].querySelector('img');
    stageImg.src = src.getAttribute('data-full') || src.src;
    stageImg.alt = src.alt || '';
    countEl.textContent = (idx + 1) + ' / ' + items.length;
  }
  function open(i) {
    lastFocus = document.activeElement;
    show(i);
    lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lb.querySelector('[data-lightbox-close]').focus();
  }
  function close() {
    lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    stageImg.src = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  items.forEach(function (el, i) {
    el.addEventListener('click', function () { open(i); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); } });
  });
  lb.addEventListener('click', function (e) {
    if (e.target.closest('[data-lightbox-close]')) close();
    else if (e.target.closest('[data-lightbox-next]')) show(idx + 1);
    else if (e.target.closest('[data-lightbox-prev]')) show(idx - 1);
  });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') show(idx + 1);
    else if (e.key === 'ArrowLeft') show(idx - 1);
  });
  if (items.length < 2) { lb.querySelector('[data-lightbox-prev]').style.display = 'none'; lb.querySelector('[data-lightbox-next]').style.display = 'none'; }
  var touchX = null;
  lb.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', function (e) {
    if (touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
    touchX = null;
  }, { passive: true });
})();
